import {FC} from "react";
import {Team} from "../../../lib/src/api/dto/Team"
import {ModalFooter} from "../../../lib/src/components/layout/ModalProvider";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import {useApi} from "../api/APIContext";

export const DeleteTemporaryTeamModal: FC<{ team: Team }> = (props) => {
  const {deleteTemporaryTeam} = useApi()

  const deleteTemporary = async () => {
    await deleteTemporaryTeam(props.team.id)
  }

  return <div>
    <div>
      <div>Weet je zeker dat je het voldende tijdelijke team wilt verwijderen?</div>
      <div className={'font-bold'}>&middot; {props.team.name}</div>
    </div>
    <ModalFooter text={'Verwijderen'} icon={faTrash} onSubmit={deleteTemporary} />
  </div>
}